(() => {
    
  let lastScrollY = 0;
  
  const openModalById = (id) => {
    const modal = document.getElementById(id);
    if (!modal) return;

    lastScrollY = window.scrollY;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.dataset.ghlPopupOpen = 'true';
    document.body.style.overflow = 'hidden';

    // focus close button for accessibility
    const closeBtn = modal.querySelector('[data-ghl-close]');
    closeBtn && closeBtn.focus();
  };

  const closeModal = (modal) => {
    if (!modal) return;

    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    delete document.body.dataset.ghlPopupOpen;
    document.body.style.overflow = '';
    window.scrollTo(0, lastScrollY);
  };

  // Open trigger anywhere on page:
  // <button data-ghl-modal-open="GhlPopup-SECTIONID">Open</button>
  
document.addEventListener('click', (e) => {
  const opener = e.target.closest('[data-ghl-modal-open]');
  if (opener) {
    e.preventDefault();
    const id = opener.getAttribute('data-ghl-modal-open');
    if (id) openModalById(id);
    return;
  }

  const closer = e.target.closest('[data-ghl-close]');
  if (closer) {
    e.preventDefault();
    const modal = closer.closest('[data-ghl-popup]');
    if (modal) closeModal(modal);
  }
}, true);

  // Escape closes the currently open modal
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const openModal = document.querySelector('[data-ghl-popup]:not([hidden])');
    closeModal(openModal);
  });
})();


